// export const WORKSPACE_PREVIEW_SELECT = 'WORKSPACE_PREVIEW_SELECT';
export const WORKSPACE_PREVIEW_RETRIEVE_REQUEST = 'WORKSPACE_PREVIEW_RETRIEVE_REQUEST';
export const WORKSPACE_PREVIEW_RETRIEVE_SUCCESS = 'WORKSPACE_PREVIEW_RETRIEVE_SUCCESS';
export const WORKSPACE_PREVIEW_RETRIEVE_FAILURE = 'WORKSPACE_PREVIEW_RETRIEVE_FAILURE';

export const WORKSPACE_PREVIEW_SELECT_TOGGLE = 'WORKSPACE_PREVIEW_SELECT_TOGGLE';
export const WORKSPACE_PREVIEW_SELECT_ALL = 'WORKSPACE_PREVIEW_SELECT_ALL';
export const WORKSPACE_PREVIEW_DESELECT_ALL = 'WORKSPACE_PREVIEW_DESELECT_ALL';



// WEBPACK FOOTER //
// ./src/js/actions/workspacePreviewActionTypes.js